// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76cfbfdc","239":"5609229f","455":"2ecd731b"}[chunkId] + ".chunk.js";
};